import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import Button from "../Components/Button";
import ErrorMessage from "../Components/ErrorMessage";
import InputBoxDisableTrans from "../Components/InputBoxDisableTrans";
import Footer from "../Layout/Footer";
import "../Styles/global.css";

const PASSWORD_RESET_EMAIL_KEY = "passwordResetEmail";

const ResetPW = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const email = localStorage.getItem(PASSWORD_RESET_EMAIL_KEY);
  const [newPassword, setNewPassword] = useState("");
  const [newPassword2, setNewPassword2] = useState("");
  const [error_message1, setError_message1] = useState("");
  const [error_message2, setError_message2] = useState("");
  const [hasError, setHasError] = useState(false);

  const handleInput_password1 = (value) => {
    setNewPassword(value);
  };
  const handleInput_password2 = (value) => {
    setNewPassword2(value);
  };

  const resetPassword = async () => {
    // 비밀번호 재설정 성공 시 navigate 실행
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/dashboard/auth/updatePassword`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email,
            newPassword: newPassword,
            newPassword2: newPassword2,
          }),
        }
      );
      const data = await response.json();
      if (data.code === 200) {
        localStorage.removeItem(PASSWORD_RESET_EMAIL_KEY);
        localStorage.removeItem("sentTime");
        navigate("/login", { state: { toast_enable: true } });
      } else if (data.code === 1002) {
        setError_message1("");
        setError_message2("파트너스 정보가 없습니다.");
        setHasError(true);
      } else if (data.code === 1007) {
        setError_message1("");
        setError_message2(
          "비밀번호가 일치하지 않습니다. 다시 한번 입력해 주세요."
        );
        setHasError(true);
      } else if (data.code === 1008) {
        setError_message1(
          "비밀번호는 8~16자리(영문/숫자/특수문자)로 입력할 수 있어요."
        );
        setError_message2(
          "비밀번호는 8~16자리(영문/숫자/특수문자)로 입력할 수 있어요."
        );
        setHasError(true);
      } else if (data.code === 1009) {
        setError_message1(
          "비밀번호는 8~16자리(영문/숫자/특수문자)로 입력할 수 있어요."
        );
        setError_message2(
          "비밀번호는 8~16자리(영문/숫자/특수문자)로 입력할 수 있어요."
        );
        setHasError(true);
      }
    } catch (error) {
      console.error("비밀번호 재설정 중 에러: ", error);
    }
  };

  useEffect(() => {
    if (!location.state?.certified || !email) {
      navigate("/emailauth");
    }
  }, [email, location.state, navigate]);

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  return (
    <div className="page-wrapper center">
      <div>
        <ResetBox>
          <h1>비밀번호 재설정</h1>
          <p style={{ marginTop: 10 }}>비밀번호를 다시 설정해주세요.</p>
          <div style={{ marginTop: 30 }}>
            <InputBoxDisableTrans
              message="비밀번호 입력(영문/숫자/특수문자 8~16자리)"
              type="password"
              handleInput={handleInput_password1}
              hasError={hasError}
              setError_message={(value) => setError_message1(value)}
            />
          </div>

          {error_message1 && <ErrorMessage message={error_message1} />}

          <div style={{ marginTop: 10 }}>
            <InputBoxDisableTrans
              message="비밀번호 재입력"
              type="password"
              handleInput={handleInput_password2}
              hasError={hasError}
              setError_message={(value) => setError_message2(value)}
            />
          </div>

          {error_message2 && <ErrorMessage message={error_message2} />}
          <div onClick={resetPassword} style={{ marginTop: 30 }}>
            <Button message="완료" />
          </div>
        </ResetBox>
      </div>
      <Footer />
    </div>
  );
};

const ResetBox = styled.div`
  width: 400px;
  height: auto;
  margin-top: 240px;
  margin-bottom: 140px;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: "notoSans";
  > h1 {
    margin: 0;
    font-size: 30px;
    font-weight: bold;
  }
  > p {
    font-size: 16px;
    color: #888888;
    margin: 0;
  }
`;

export default ResetPW;
